import { bizchatSidepaneStore } from "../store/store";
import { getBizChatCompositeKey } from "../utils/getBizChatCompositeKey";
import { getAccountKeyForMailboxInfo, type MailboxInfo } from "owa-client-types";
import type { WindowKey } from "owa-bizchat-types";

export function shouldShowLoadingUi(mailboxInfo: MailboxInfo, windowKey: WindowKey): boolean {
    const key = getBizChatCompositeKey(getAccountKeyForMailboxInfo(mailboxInfo), windowKey);
    return !bizchatSidepaneStore().isBizchatSidepaneLoadedMap.get(key);
}
